/* eslint-disable react/prop-types */
import React from "react";
import IntlMessages from "../../helpers/IntlMessages";
import RequestListItem from "./RequestListItem";

const RequestList = ({ requests, loading, match }) => {
  if (requests && requests.length) {
    return requests.map(item => (
      <RequestListItem
        key={item.id}
        item={item}
        isSelected
        // isSelected={loading ? selectedItems.includes(item.id) : false}

        match={match}
      />
    ));
  }
  if (loading) {
    return (
      <div className="text-center">
        {/* <i className="iconsminds-information text-muted" style={{ fontSize: '25px' }} /> */}
        <div className="list-item-heading mb-2 text-muted px-4" style={{ fontSize: "25px" }}>
          <i className="iconsminds-inbox-empty text-muted" />
          <IntlMessages id="request.empty_request_list" />
        </div>
      </div>
    );
  }
  return <div className="loading" />;
};

export default React.memo(RequestList);
